












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PartnerApi from '@/api/partner'

@Component({})
export default class OrderLog extends Vue {
	private needExpand: boolean = false
	private expanded: boolean = false
	private current: number = 0
	private logData: any[] = []

	@Prop()
	private orderId!: string

	@Prop()
	private dispatchId!: string

	@Watch('dispatchId', { immediate: true })
	private onDispatchIdChange() {
		if (!this.dispatchId) {
			return
		}
		this.getTaskLog()
	}

	private getTaskLog() {
		PartnerApi.getTaskLog({
			orderId: this.orderId,
			dispatchId: this.dispatchId,
		}).then((res: any) => {
			this.logData = res.data
			this.needExpand = this.logData.length >= 5
		})
	}
}
